module.exports = __webpack_public_path__ + "static/media/update.9966c7e1.svg";